document.addEventListener("DOMContentLoaded", () => {
    const canvas = document.querySelector("#hero-canvas");
    if (!canvas) return;

    const ctx = canvas.getContext("2d");

    // 1. Maintain the upscaled 60px grid structure
    const BLOCK_SIZE = 60;
    let cols = 0;
    let rows = 0;

    // Direct RGB translations of your brand design system palette
    const colorBlue = [0, 84, 166];
    const colorLime = [223, 248, 3];

    // Starting hue of your brand blue (0, 84, 166 translates to ~210 degrees on the HSL color wheel)
    let baseHue = 210;
    let colorWave = [0, 84, 166];

    // Helper: Converts HSL colors to RGB arrays dynamically
    function hslToRgb(h, s, l) {
        h /= 360;
        s /= 100;
        l /= 100;
        let r, g, b;

        if (s === 0) {
            r = g = b = l; // achromatic
        } else {
            const hue2rgb = (p, q, t) => {
                if (t < 0) t += 1;
                if (t > 1) t -= 1;
                if (t < 1 / 6) return p + (q - p) * 6 * t;
                if (t < 1 / 2) return q;
                if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                return p;
            };

            const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            const p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }

        return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
    }

    function resize() {
        canvas.width = window.innerWidth;
        // Always restrict height to the viewport height
        canvas.height = window.innerHeight;

        cols = Math.ceil(canvas.width / BLOCK_SIZE);
        rows = Math.ceil(canvas.height / BLOCK_SIZE);
    }
    resize();
    window.addEventListener("resize", resize);

    // Timers for tracking the independent wave layers
    let waveTimeA = 1500;
    let waveTimeB = 3200;
    let hueTime = 0; // Separate timer for tracking our ultra-slow hue drift

    function drawOrganicPixelWave() {
        requestAnimationFrame(drawOrganicPixelWave);

        // 2. Ultra-slow independent step speeds to keep the motion incredibly calm
        waveTimeA += 0.006; // Controls primary blue wave velocity
        waveTimeB += 0.004; // Controls cross-cutting lime bloom velocity

        // Drifts the hue angle ever so slowly.
        // 0.015 creates a very slow, hypnotic color cycle.
        hueTime += 0.015;

        // Swing the Hue back and forth by 15 degrees from our brand-blue (210)
        // This limits the drift strictly between 195 (teal-blue) and 225 (royal indigo)
        const currentHue = baseHue + Math.sin(hueTime) * 15;

        // Convert our moving HSL vector (Hue, 100% Saturation, 33% Lightness) back to RGB
        colorWave = hslToRgb(currentHue, 100, 33);

        // Clear frame to process alpha transparent calculations properly
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Scan the cell matrix row by row
        for (let x = 0; x < cols; x++) {
            for (let y = 0; y < rows; y++) {
                // 3. SYNTHESIZE WAVE A (Primary Ambient Blue Wave)
                const waveA = Math.sin(x * 0.12 + y * 0.18 + waveTimeA) * 0.5 + 0.5;

                // 4. SYNTHESIZE WAVE B (Secondary Cross-Cutting Wave)
                const waveB = Math.cos(x * 0.22 - y * 0.12 + waveTimeB) * 0.5 + 0.5;

                // 5. COMBINE THE FORCES
                const intersectionIntensity = Math.pow(waveA * waveB, 2);

                // Default starting point: Core Royal Blue integers
                let currentR = colorBlue[0];
                let currentG = colorBlue[1];
                let currentB = colorBlue[2];

                // Smoothly collide and morph toward our dynamically shifting colorWave value
                currentR = currentR + (colorWave[0] - currentR) * intersectionIntensity * 0.75;
                currentG = currentG + (colorWave[1] - currentG) * intersectionIntensity * 0.75;
                currentB = currentB + (colorWave[2] - currentB) * intersectionIntensity * 0.75;

                // 6. CALCULATE COMPLEMENTARY TRANSPARENCY SHIFTS
                let currentAlpha = waveA * 0.2 + intersectionIntensity * 0.25;

                // 7. RENDER THE DYNAMIC ALPHA CELL
                ctx.fillStyle = `rgba(${Math.floor(currentR)}, ${Math.floor(currentG)}, ${Math.floor(currentB)}, ${currentAlpha})`;
                ctx.fillRect(x * BLOCK_SIZE, y * BLOCK_SIZE, BLOCK_SIZE, BLOCK_SIZE);
            }
        }
    }

    drawOrganicPixelWave();
});
